import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AvatarService {
  // Cached default avatar as data URL to avoid repeated requests
  private readonly defaultAvatarUrl: string;

  constructor() {
    // Create a simple SVG avatar as data URL
    this.defaultAvatarUrl = 'data:image/svg+xml;base64,' + btoa(`
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="20" fill="#e2e8f0"/>
        <circle cx="20" cy="16" r="6" fill="#94a3b8"/>
        <path d="M8 32c0-6.627 5.373-12 12-12s12 5.373 12 12" fill="#94a3b8"/>
      </svg>
    `);
  }

  /**
   * Get the default avatar URL
   */
  getDefaultAvatarUrl(): string {
    return this.defaultAvatarUrl;
  }

  /**
   * Handle image loading errors by setting the default avatar
   */
  handleImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    if (target && target.src !== this.defaultAvatarUrl) {
      target.src = this.defaultAvatarUrl;
    }
  }

  /**
   * Get initials from a name for avatar placeholders
   */
  getInitials(name: string): string {
    if (!name) return '?';
    const names = name.trim().split(' ');
    if (names.length >= 2) {
      return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`.toUpperCase();
    }
    return name.charAt(0).toUpperCase();
  }
}

